

// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/HorasSocialesRector.css";

// const API = process.env.REACT_APP_API || "http://3.236.217.225:5001/api";

// export default function HorasSocialesRector() {

//   const { token } = useAuth();

//   const headers = {
//     Authorization: `Bearer ${token}`
//   };

//   /* =========================
//      ESTADOS
//   ========================= */

//   const [sedes, setSedes] = useState([]);
//   const [estructura, setEstructura] = useState([]);
//   const [actividades, setActividades] = useState([]);
//   const [profesores, setProfesores] = useState([]);

//   const [sedeId, setSedeId] = useState(""); // "" | "tenant" | id

//   const [estudianteId, setEstudianteId] = useState("");
//   const [actividadId, setActividadId] = useState("");
//   const [profesorId, setProfesorId] = useState("");

//   const [nombreActividad, setNombreActividad] = useState("");
//   const [descripcion, setDescripcion] = useState("");
//   const [horasMaximas, setHorasMaximas] = useState("");

//   const [loading, setLoading] = useState(false);

//   const [asignaciones, setAsignaciones] = useState([]);
//   const [resumenHoras, setResumenHoras] = useState([]);

//   /* =========================
//      CARGAR SEDES
//   ========================= */

//   useEffect(() => {
//     const cargarSedes = async () => {
//       try {
//         const res = await axios.get(
//           `${API}/director-grupo/sedes`,
//           { headers }
//         );

//         setSedes(res.data.sedes || []);
//       } catch (err) {
//         console.error("❌ Error cargando sedes:", err);
//         setSedes([]);
//       }
//     };

//     cargarSedes();
//   }, []);

//   /* =========================
//      CARGAR DATOS
//   ========================= */

//   useEffect(() => {

//     if (!sedeId) return;

//     const sedeQuery = sedeId === "tenant" ? "" : sedeId;

//     const cargarDatos = async () => {

//       try {

//         setLoading(true);

//         const [
//           resEstructura,
//           resActividades,
//           resProfesores,
//           resAsignaciones,
//           resResumen
//         ] = await Promise.all([

//           axios.get(`${API}/horas-sociales/estructura?sede_id=${sedeQuery}`, { headers }),
//           axios.get(`${API}/horas-sociales/actividades?sede_id=${sedeQuery}`, { headers }),
//           axios.get(`${API}/horas-sociales/profesores?sede_id=${sedeQuery}`, { headers }),
//           axios.get(`${API}/horas-sociales/asignaciones?sede_id=${sedeQuery}`, { headers }),
//           axios.get(`${API}/horas-sociales/resumen?sede_id=${sedeQuery}`, { headers })

//         ]);

//         setEstructura(resEstructura.data.data || []);
//         setActividades(resActividades.data.actividades || []);
//         setProfesores(resProfesores.data.profesores || []);
//         setAsignaciones(resAsignaciones.data.asignaciones || []);
//         setResumenHoras(resResumen.data.resumen || []);

//       } catch (err) {
//         console.error("❌ Error cargando datos:", err);
//       } finally {
//         setLoading(false);
//       }

//     };

//     cargarDatos();

//   }, [sedeId]);

//   /* =========================
//      CREAR ACTIVIDAD
//   ========================= */

//   const crearActividad = async () => {

//     if (!nombreActividad || !horasMaximas) {
//       return alert("Complete los campos obligatorios");
//     }

//     try {

//       setLoading(true);

//       await axios.post(
//         `${API}/horas-sociales/actividades`,
//         {
//           nombre: nombreActividad,
//           descripcion,
//           horas_maximas: Number(horasMaximas),
//           sede_id: sedeId === "tenant" ? null : sedeId
//         },
//         { headers }
//       );

//       alert("Actividad creada");

//       setNombreActividad("");
//       setDescripcion("");
//       setHorasMaximas("");

//       const sedeQuery = sedeId === "tenant" ? "" : sedeId;

//       const res = await axios.get(
//         `${API}/horas-sociales/actividades?sede_id=${sedeQuery}`,
//         { headers }
//       );

//       setActividades(res.data.actividades || []);

//     } catch (err) {
//       console.error(err);
//       alert("Error creando actividad");
//     } finally {
//       setLoading(false);
//     }

//   };

//   /* =========================
//      ASIGNAR ACTIVIDAD
//   ========================= */

//   const asignar = async () => {

//     if (!estudianteId || !actividadId || !profesorId) {
//       return alert("Seleccione todos los campos");
//     }

//     try {

//       setLoading(true);

//       await axios.post(
//         `${API}/horas-sociales/asignar`,
//         {
//           estudiante_id: estudianteId,
//           actividad_id: actividadId,
//           profesor_responsable_id: profesorId,
//           sede_id: sedeId === "tenant" ? null : sedeId
//         },
//         { headers }
//       );

//       alert("Actividad asignada");

//       const sedeQuery = sedeId === "tenant" ? "" : sedeId;

//       const [resAsignaciones, resResumen] = await Promise.all([

//         axios.get(`${API}/horas-sociales/asignaciones?sede_id=${sedeQuery}`, { headers }),
//         axios.get(`${API}/horas-sociales/resumen?sede_id=${sedeQuery}`, { headers })

//       ]);

//       setAsignaciones(resAsignaciones.data.asignaciones || []);
//       setResumenHoras(resResumen.data.resumen || []);

//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || "Error asignando");
//     } finally {
//       setLoading(false);
//     }

//   };

//   /* =========================
//      RENDER
//   ========================= */

//   return (

//     <div className="horas-sociales-container">

//       <h2>Horas Sociales – Rector</h2>

//       {loading && <p className="loading">Procesando...</p>}

//       {/* SELECT SEDE / TENANT */}
//       <select
//         value={sedeId}
//         onChange={(e) => setSedeId(e.target.value)}
//       >
//         <option value="">Seleccione ámbito</option>
//         <option value="tenant">🏫 Colegio principal (Tenant)</option>

//         {sedes.map((s) => (
//           <option key={s.id} value={s.id}>
//             {s.nombre}
//           </option>
//         ))}
//       </select>

//       {/* ASIGNAR */}
//       <div className="card">

//         <h3>Asignar actividad</h3>

//         <div className="form-grid">

//           <select
//             value={estudianteId}
//             onChange={(e) => setEstudianteId(e.target.value)}
//           >
//             <option value="">Seleccione estudiante</option>

//             {estructura.map((e) => (
//               <option key={e.estudiante_id} value={e.estudiante_id}>
//                 {e.nombres_estudiante} {e.apellidos_estudiante} – {e.grado}{e.grupo}
//               </option>
//             ))}
//           </select>

//           <select
//             value={actividadId}
//             onChange={(e) => setActividadId(e.target.value)}
//           >
//             <option value="">Seleccione actividad</option>

//             {actividades.map((a) => (
//               <option key={a.id} value={a.id}>
//                 {a.nombre} ({a.horas_maximas}h)
//               </option>
//             ))}
//           </select>

//           <select
//             value={profesorId}
//             onChange={(e) => setProfesorId(e.target.value)}
//           >
//             <option value="">Profesor responsable</option>

//             {profesores.map((p) => (
//               <option key={p.id} value={p.id}>
//                 {p.nombre}
//               </option>
//             ))}
//           </select>

//         </div>

//         <button className="btn-primary" onClick={asignar}>
//           Asignar actividad
//         </button>

//       </div>

//       {/* CREAR */}
//       <div className="card">

//         <h3>Crear actividad</h3>

//         <div className="form-grid">

//           <input
//             placeholder="Nombre actividad"
//             value={nombreActividad}
//             onChange={(e) => setNombreActividad(e.target.value)}
//           />

//           <input
//             type="number"
//             placeholder="Horas máximas"
//             value={horasMaximas}
//             onChange={(e) => setHorasMaximas(e.target.value)}
//           />

//           <textarea
//             placeholder="Descripción"
//             value={descripcion}
//             onChange={(e) => setDescripcion(e.target.value)}
//           />

//         </div>

//         <button className="btn-secondary" onClick={crearActividad}>
//           Crear actividad
//         </button>

//       </div>

//       {/* ASIGNACIONES */}
//       <div className="card">

//         <h3>Asignaciones realizadas</h3>

//         <table>
//           <thead>
//             <tr>
//               <th>Estudiante</th>
//               <th>Actividad</th>
//               <th>Profesor</th>
//               <th>Estado</th>
//             </tr>
//           </thead>

//           <tbody>
//             {asignaciones.map((a) => (
//               <tr key={a.id}>
//                 <td>{a.nombres_estudiante} {a.apellidos_estudiante}</td>
//                 <td>{a.nombre_actividad}</td>
//                 <td>{a.nombre_profesor}</td>
//                 <td>{a.estado}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//       </div>

//       {/* RESUMEN */}
//       <div className="card">

//         <h3>Resumen de horas</h3>

//         <table>
//           <thead>
//             <tr>
//               <th>Estudiante</th>
//               <th>Horas asignadas</th>
//               <th>Horas registradas</th>
//             </tr>
//           </thead>

//           <tbody>
//             {resumenHoras.map((r) => (
//               <tr key={r.estudiante_id}>
//                 <td>{r.nombres_estudiante} {r.apellidos_estudiante}</td>
//                 <td>{r.horas_asignadas}</td>
//                 <td>{r.horas_registradas}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//       </div>

//     </div>

//   );
// }


///

// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import { API } from "../config"; // ✅ Importación centralizada
// import "../../style/HorasSocialesRector.css";

// export default function HorasSocialesRector() {
//   const { token, user } = useAuth();

//   // Memoizar headers para evitar recreación innecesaria
//   const headers = useMemo(() => ({
//     Authorization: `Bearer ${token}`
//   }), [token]);

//   /* =========================
//       ESTADOS
//   ========================= */
//   const [sedes, setSedes] = useState([]);
//   const [sedeId, setSedeId] = useState(""); // "" | "tenant" | id

//   const [estructura, setEstructura] = useState([]);
//   const [actividades, setActividades] = useState([]);
//   const [profesores, setProfesores] = useState([]);
//   const [asignaciones, setAsignaciones] = useState([]);
//   const [resumenHoras, setResumenHoras] = useState([]);

//   // Formulario Asignación
//   const [estudianteId, setEstudianteId] = useState("");
//   const [actividadId, setActividadId] = useState("");
//   const [profesorId, setProfesorId] = useState("");

//   // Formulario Creación Actividad
//   const [nombreActividad, setNombreActividad] = useState("");
//   const [descripcion, setDescripcion] = useState("");
//   const [horasMaximas, setHorasMaximas] = useState("");

//   const [loading, setLoading] = useState(false);

//   /* =========================
//       CARGAR SEDES
//   ========================= */
//   useEffect(() => {
//     if (!token) return;
//     const cargarSedes = async () => {
//       try {
//         const res = await axios.get(`${API}/director-grupo/sedes`, { headers });
//         setSedes(res.data.sedes || []);
//       } catch (err) {
//         console.error("❌ Error cargando sedes:", err);
//       }
//     };
//     cargarSedes();
//   }, [token, headers]);

//   /* =========================
//       CARGAR DATOS DINÁMICOS
//   ========================= */
//   const cargarDatosSede = useCallback(async () => {
//     if (!sedeId) return;
//     const sedeQuery = sedeId === "tenant" ? "" : sedeId;
    
//     try {
//       setLoading(true);
//       const [
//         resEstructura,
//         resActividades,
//         resProfesores,
//         resAsignaciones,
//         resResumen
//       ] = await Promise.all([
//         axios.get(`${API}/horas-sociales/estructura?sede_id=${sedeQuery}`, { headers }),
//         axios.get(`${API}/horas-sociales/actividades?sede_id=${sedeQuery}`, { headers }),
//         axios.get(`${API}/horas-sociales/profesores?sede_id=${sedeQuery}`, { headers }),
//         axios.get(`${API}/horas-sociales/asignaciones?sede_id=${sedeQuery}`, { headers }),
//         axios.get(`${API}/horas-sociales/resumen?sede_id=${sedeQuery}`, { headers })
//       ]);

//       setEstructura(resEstructura.data.data || []);
//       setActividades(resActividades.data.actividades || []);
//       setProfesores(resProfesores.data.profesores || []);
//       setAsignaciones(resAsignaciones.data.asignaciones || []);
//       setResumenHoras(resResumen.data.resumen || []);
//     } catch (err) {
//       console.error("❌ Error cargando datos de la sede:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [sedeId, headers]);

//   useEffect(() => {
//     cargarDatosSede();
//   }, [cargarDatosSede]);

//   /* =========================
//       ACCIONES
//   ========================= */
//   const crearActividad = async (e) => {
//     e.preventDefault();
//     if (!nombreActividad || !horasMaximas) return alert("Nombre y Horas son obligatorios");

//     try {
//       setLoading(true);
//       await axios.post(`${API}/horas-sociales/actividades`, {
//         nombre: nombreActividad,
//         descripcion,
//         horas_maximas: Number(horasMaximas),
//         sede_id: sedeId === "tenant" ? null : sedeId
//       }, { headers });

//       alert("✅ Actividad creada");
//       setNombreActividad("");
//       setDescripcion("");
//       setHorasMaximas("");
//       cargarDatosSede();
//     } catch (err) {
//       alert("Error al crear actividad");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const asignarActividad = async () => {
//     if (!estudianteId || !actividadId || !profesorId) return alert("Seleccione todos los campos");

//     try {
//       setLoading(true);
//       await axios.post(`${API}/horas-sociales/asignar`, {
//         estudiante_id: estudianteId,
//         actividad_id: actividadId,
//         profesor_responsable_id: profesorId,
//         sede_id: sedeId === "tenant" ? null : sedeId
//       }, { headers });

//       alert("✅ Actividad asignada correctamente");
//       setEstudianteId("");
//       setActividadId("");
//       setProfesorId("");
//       cargarDatosSede();
//     } catch (err) {
//       alert(err.response?.data?.message || "Error al asignar");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="horas-sociales-container">
//       <header className="header-seccion">
//         <h2>🎓 Gestión de Horas Sociales (Rectoría)</h2>
//       </header>

//       <div className="selector-ambito">
//         <label>Ámbito de gestión:</label>
//         <select value={sedeId} onChange={(e) => setSedeId(e.target.value)}>
//           <option value="">-- Seleccione sede o colegio --</option>
//           <option value="tenant">🏫 Institución (Sede Principal)</option>
//           {sedes.map((s) => (
//             <option key={s.id} value={s.id}>📍 {s.nombre}</option>
//           ))}
//         </select>
//       </div>

//       {sedeId && (
//         <div className="grid-dashboard fade-in">
          
//           {/* COLUMNA IZQUIERDA: FORMULARIOS */}
//           <div className="column-forms">
//             <section className="card">
//               <h3>📝 Asignar Estudiante a Actividad</h3>
//               <div className="form-vertical">
//                 <select value={estudianteId} onChange={(e) => setEstudianteId(e.target.value)}>
//                   <option value="">Seleccione estudiante...</option>
//                   {estructura.map((e) => (
//                     <option key={e.estudiante_id} value={e.estudiante_id}>
//                       {e.apellidos_estudiante}, {e.nombres_estudiante} ({e.grado}{e.grupo})
//                     </option>
//                   ))}
//                 </select>

//                 <select value={actividadId} onChange={(e) => setActividadId(e.target.value)}>
//                   <option value="">Seleccione actividad...</option>
//                   {actividades.map((a) => (
//                     <option key={a.id} value={a.id}>{a.nombre} - Max: {a.horas_maximas}h</option>
//                   ))}
//                 </select>

//                 <select value={profesorId} onChange={(e) => setProfesorId(e.target.value)}>
//                   <option value="">Profesor responsable...</option>
//                   {profesores.map((p) => (
//                     <option key={p.id} value={p.id}>{p.nombre}</option>
//                   ))}
//                 </select>

//                 <button className="btn-primary" onClick={asignarActividad} disabled={loading}>
//                   {loading ? "Procesando..." : "Realizar Asignación"}
//                 </button>
//               </div>
//             </section>

//             <section className="card">
//               <h3>🆕 Nueva Actividad Social</h3>
//               <form onSubmit={crearActividad} className="form-vertical">
//                 <input 
//                   placeholder="Nombre de la actividad" 
//                   value={nombreActividad} 
//                   onChange={(e) => setNombreActividad(e.target.value)} 
//                 />
//                 <input 
//                   type="number" 
//                   placeholder="Cupo total de horas" 
//                   value={horasMaximas} 
//                   onChange={(e) => setHorasMaximas(e.target.value)} 
//                 />
//                 <textarea 
//                   placeholder="Breve descripción..." 
//                   value={descripcion} 
//                   onChange={(e) => setDescripcion(e.target.value)}
//                 />
//                 <button type="submit" className="btn-secondary" disabled={loading}>
//                   Crear Actividad
//                 </button>
//               </form>
//             </section>
//           </div>

//           {/* COLUMNA DERECHA: TABLAS */}
//           <div className="column-tables">
//             <section className="card table-card">
//               <h3>📋 Asignaciones Actuales</h3>
//               <div className="table-responsive">
//                 <table>
//                   <thead>
//                     <tr>
//                       <th>Estudiante</th>
//                       <th>Actividad</th>
//                       <th>Responsable</th>
//                       <th>Estado</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {asignaciones.map((a) => (
//                       <tr key={a.id}>
//                         <td><small>{a.nombres_estudiante} {a.apellidos_estudiante}</small></td>
//                         <td>{a.nombre_actividad}</td>
//                         <td>{a.nombre_profesor}</td>
//                         <td><span className={`status ${a.estado.toLowerCase()}`}>{a.estado}</span></td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </section>

//             <section className="card table-card">
//               <h3>📊 Resumen de Cumplimiento</h3>
//               <div className="table-responsive">
//                 <table>
//                   <thead>
//                     <tr>
//                       <th>Estudiante</th>
//                       <th>Asignadas</th>
//                       <th>Registradas</th>
//                       <th>Progreso</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {resumenHoras.map((r) => (
//                       <tr key={r.estudiante_id}>
//                         <td>{r.nombres_estudiante} {r.apellidos_estudiante}</td>
//                         <td>{r.horas_asignadas}h</td>
//                         <td><strong>{r.horas_registradas}h</strong></td>
//                         <td>
//                           <div className="progress-bar-bg">
//                             <div 
//                               className="progress-bar-fill" 
//                               style={{ width: `${Math.min((r.horas_registradas/r.horas_asignadas)*100, 100)}%` }}
//                             ></div>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </section>
//           </div>

//         </div>
//       )}
//     </div>
//   );
// }



//
import React, {
  useEffect,
  useState,
  useCallback
} from "react";

import axios from "../../api/axiosAuth";

import "../../style/HorasSocialesRector.css";

export default function HorasSocialesRector() {

  /* =========================
      ESTADOS
  ========================= */

  const [estructura, setEstructura] = useState([]);
  const [actividades, setActividades] = useState([]);
  const [profesores, setProfesores] = useState([]);
  const [asignaciones, setAsignaciones] = useState([]);
  const [resumenHoras, setResumenHoras] = useState([]);

  const [estudianteId, setEstudianteId] = useState("");
  const [actividadId, setActividadId] = useState("");
  const [profesorId, setProfesorId] = useState("");

  const [nombreActividad, setNombreActividad] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [horasMaximas, setHorasMaximas] = useState("");

  const [loading, setLoading] = useState(false);

  /* =========================
      CARGAR DATOS
  ========================= */

  const cargarDatos = useCallback(async () => {

    try {

      setLoading(true);

      const [

        resEstudiantes,

        resActividades,

        resProfesores,

        resAsignaciones,

        resResumen

      ] = await Promise.all([

        axios.get("/horas-sociales/estructura"),

        axios.get("/horas-sociales/actividades"),

        axios.get("/horas-sociales/profesores"),

        axios.get("/horas-sociales/asignaciones"),

        axios.get("/horas-sociales/resumen")

      ]);

      /* =========================
          ESTUDIANTES
      ========================= */

      setEstructura(

        Array.isArray(
          resEstudiantes.data?.data
        )

          ? resEstudiantes.data.data

          : []

      );

      /* =========================
          ACTIVIDADES
      ========================= */

      setActividades(

        Array.isArray(
          resActividades.data?.actividades
        )

          ? resActividades.data.actividades

          : []

      );

      /* =========================
          PROFESORES
      ========================= */

      setProfesores(

        Array.isArray(
          resProfesores.data?.profesores
        )

          ? resProfesores.data.profesores

          : []

      );

      /* =========================
          ASIGNACIONES
      ========================= */

      setAsignaciones(

        Array.isArray(
          resAsignaciones.data?.asignaciones
        )

          ? resAsignaciones.data.asignaciones

          : []

      );

      /* =========================
          RESUMEN
      ========================= */

      setResumenHoras(

        Array.isArray(
          resResumen.data?.resumen
        )

          ? resResumen.data.resumen

          : []

      );

    } catch (error) {

      console.error(
        "❌ Error cargando datos:",
        error
      );

      alert(

        error.response?.data?.message ||

        "Error cargando la información"

      );

    } finally {

      setLoading(false);

    }

  }, []);

  /* =========================
      INICIO
  ========================= */

  useEffect(() => {

    cargarDatos();

  }, [cargarDatos]);

  /* =========================
      CREAR ACTIVIDAD
  ========================= */

  const crearActividad = async (e) => {

    e.preventDefault();

    if (

      !nombreActividad.trim() ||

      !horasMaximas

    ) {

      return alert(

        "Nombre y horas son obligatorios"

      );
    }

    try {

      setLoading(true);

      await axios.post(

        "/horas-sociales/actividades",

        {

          nombre: nombreActividad,

          descripcion,

          horas_maximas:

            Number(horasMaximas)

        }

      );

      alert(

        "✅ Actividad creada"

      );

      setNombreActividad("");

      setDescripcion("");

      setHorasMaximas("");

      await cargarDatos();

    } catch (error) {

      alert(

        error.response?.data?.message ||

        "Error al crear actividad"

      );

    } finally {

      setLoading(false);

    }

  };

  /* =========================
      ASIGNAR ACTIVIDAD
  ========================= */

  const asignarActividad = async () => {

    if (

      !estudianteId ||

      !actividadId ||

      !profesorId

    ) {

      return alert(

        "Seleccione todos los campos"

      );
    }

    try {

      setLoading(true);

      await axios.post(

        "/horas-sociales/asignar",

        {

          estudiante_id:

            Number(estudianteId),

          actividad_id:

            Number(actividadId),

          profesor_responsable_id:

            Number(profesorId)

        }

      );

      alert(

        "✅ Actividad asignada correctamente"

      );

      setEstudianteId("");

      setActividadId("");

      setProfesorId("");

      await cargarDatos();

    } catch (error) {

      alert(

        error.response?.data?.message ||

        "Error al asignar"

      );

    } finally {

      setLoading(false);

    }

  };




  return (

    <div className="horas-sociales-container">

      <header className="header-seccion">

        <h2>

          🎓 Gestión de Horas Sociales (Rectoría)

        </h2>

      </header>

      <div className="grid-dashboard fade-in">

        {/* =========================
            FORMULARIOS
        ========================= */}

        <div className="column-forms">

          <section className="card">

            <h3>

              📝 Asignar Estudiante a Actividad

            </h3>

            <div className="form-vertical">

              <select

                value={estudianteId}

                onChange={(e) =>

                  setEstudianteId(

                    e.target.value

                  )

                }

              >

                <option value="">

                  Seleccione estudiante...

                </option>

                {estructura.map((e) => (

                  <option

                    key={e.estudiante_id}

                    value={e.estudiante_id}

                  >

                    {e.apellidos_estudiante},{" "}

                    {e.nombres_estudiante}

                    {" "}

                    ({e.grado}{e.grupo})

                  </option>

                ))}

              </select>

              <select

                value={actividadId}

                onChange={(e) =>

                  setActividadId(

                    e.target.value

                  )

                }

              >

                <option value="">

                  Seleccione actividad...

                </option>

                {actividades.map((a) => (

                  <option

                    key={a.id}

                    value={a.id}

                  >

                    {a.nombre}

                    {" - "}

                    Max: {a.horas_maximas}h

                  </option>

                ))}

              </select>

              <select

                value={profesorId}

                onChange={(e) =>

                  setProfesorId(

                    e.target.value

                  )

                }

              >

                <option value="">

                  Profesor responsable...

                </option>

                {profesores.map((p) => (

                  <option

                    key={p.id}

                    value={p.id}

                  >

                    {p.nombre_completo}

                  </option>

                ))}

              </select>

              <button

                className="btn-primary"

                onClick={asignarActividad}

                disabled={loading}

              >

                {

                  loading

                    ? "Procesando..."

                    : "Realizar Asignación"

                }

              </button>

            </div>

          </section>

          <section className="card">

            <h3>

              🆕 Nueva Actividad Social

            </h3>

            <form

              onSubmit={crearActividad}

              className="form-vertical"

            >

              <input

                placeholder="Nombre de la actividad"

                value={nombreActividad}

                onChange={(e) =>

                  setNombreActividad(

                    e.target.value

                  )

                }

              />

              <input

                type="number"

                placeholder="Horas máximas"

                value={horasMaximas}

                onChange={(e) =>

                  setHorasMaximas(

                    e.target.value

                  )

                }

              />

              <textarea

                placeholder="Descripción"

                value={descripcion}

                onChange={(e) =>

                  setDescripcion(

                    e.target.value

                  )

                }

              />

              <button

                type="submit"

                className="btn-secondary"

                disabled={loading}

              >

                Crear Actividad

              </button>

            </form>

          </section>

        </div>

        {/* =========================
            TABLAS
        ========================= */}

        <div className="column-tables">

          <section className="card table-card">

            <h3>

              📋 Asignaciones Actuales

            </h3>

            <div className="table-responsive">

              <table>

                <thead>

                  <tr>

                    <th>Estudiante</th>

                    <th>Actividad</th>

                    <th>Responsable</th>

                    <th>Estado</th>

                  </tr>

                </thead>

                <tbody>

                  {asignaciones.map((a) => (

                    <tr key={a.id}>

                      <td>

                        {a.nombres_estudiante}{" "}

                        {a.apellidos_estudiante}

                      </td>

                      <td>

                        {a.nombre_actividad}

                      </td>

                      <td>

                        {a.nombre_profesor}

                      </td>

                      <td>

                        <span

                          className={`status ${

                            a.estado?.toLowerCase()

                          }`}

                        >

                          {a.estado}

                        </span>

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </section>

          <section className="card table-card">

            <h3>

              📊 Resumen de Cumplimiento

            </h3>

            <div className="table-responsive">

              <table>

                <thead>

                  <tr>

                    <th>Estudiante</th>

                    <th>Asignadas</th>

                    <th>Registradas</th>

                    <th>Progreso</th>

                  </tr>

                </thead>

                <tbody>

                  {resumenHoras.map((r) => (

                    <tr key={r.estudiante_id}>

                      <td>

                        {r.nombres_estudiante}{" "}

                        {r.apellidos_estudiante}

                      </td>

                      <td>

                        {r.horas_asignadas}h

                      </td>

                      <td>

                        {r.horas_registradas}h

                      </td>

                      <td>

                        <div className="progress-bar-bg">

                          <div

                            className="progress-bar-fill"

                            style={{

                              width: `${Math.min(

                                (

                                  r.horas_registradas /

                                  (r.horas_asignadas || 1)

                                ) * 100,

                                100

                              )}%`

                            }}

                          />

                        </div>

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </section>

        </div>

      </div>

    </div>

  );

}